import React from "react";

import { Card, Col, Form, Row } from "react-bootstrap";

import { referralSourceOptions } from "@/context/ContactProvider.context";

import i18n from "../../../i18n";

interface ContactFormReferenceSectionProps {
  methods: any;
}

const ContactFormReferenceSection: React.FC<
  ContactFormReferenceSectionProps
> = ({ methods }): React.JSX.Element => {
  const { t } = i18n;
  const referralSource = methods.watch("referralSource");

  return (
    <Card className="mt-4 mb-4">
      <Card.Body>
        <Row>
          <Col lg={12} xs={12}>
            <Form.Group className="mb-3" controlId="referral-source">
              <Form.Label>{t("Where did you hear about us?")}</Form.Label>
              <div className="d-flex flex-wrap gap-2">
                {referralSourceOptions.map((v, i) => (
                  <Form.Check
                    key={i}
                    className="radio-pill"
                    id={`referral-source-${v}`}
                    label={t(v)}
                    type="radio"
                    value={v}
                    {...methods.register("referralSource", {
                      onChange: () => methods.trigger(["referralSource"]),
                    })}
                    isInvalid={!!methods.formState.errors.referralSource}
                    name="referralSource"
                  />
                ))}
              </div>
              <Form.Control.Feedback className="d-block" type="invalid">
                {t(methods.formState.errors.referralSource?.message)}
              </Form.Control.Feedback>
            </Form.Group>

            {referralSource &&
            (referralSource as typeof referralSourceOptions)?.includes(
              "Other",
            ) ? (
              <Form.Group className="mb-3" controlId="referral-source-other">
                <Form.Control
                  placeholder={t("Please specify...")}
                  type="text"
                  {...methods.register("referralSourceOther")}
                  isInvalid={!!methods.formState.errors.referralSourceOther}
                />
                <Form.Control.Feedback className="d-block" type="invalid">
                  {t(methods.formState.errors.referralSourceOther?.message)}
                </Form.Control.Feedback>
              </Form.Group>
            ) : null}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ContactFormReferenceSection;
